// @generated by protoc-gen-es v2.11.0 with parameter "target=ts,json_types=true"
// @generated from file route.proto (package raccoonai, syntax proto2)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { DriverOnShift, DriverOnShiftJson } from "./driver_on_shift_pb";
import { file_driver_on_shift } from "./driver_on_shift_pb";
import type { JobType, JobTypeJson, RouteCategory, RouteCategoryJson, RouteEvent, RouteEventJson, RouteStatus, RouteStatusJson, WasteType, WasteTypeJson } from "./enums_pb";
import { file_enums } from "./enums_pb";
import type { DateTimeFilter, DateTimeFilterJson, ListFilter, ListFilterJson, ListInfo, ListInfoJson } from "./general_pb";
import { file_general } from "./general_pb";
import type { StructJson, Timestamp, TimestampJson } from "@bufbuild/protobuf/wkt";
import { file_google_protobuf_struct, file_google_protobuf_timestamp } from "@bufbuild/protobuf/wkt";
import type { Job, JobCreate, JobCreateJson, JobJson, JobStop, JobStopJson } from "./job_pb";
import { file_job } from "./job_pb";
import type { Organization, OrganizationJson } from "./organization_pb";
import { file_organization } from "./organization_pb";
import type { Truck, TruckJson } from "./truck_pb";
import { file_truck } from "./truck_pb";
import type { User, UserJson } from "./user_pb";
import { file_user } from "./user_pb";
import type { JsonObject, Message } from "@bufbuild/protobuf";

/**
 * Describes the file route.proto.
 */
export const file_route: GenFile = /*@__PURE__*/
  fileDesc("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", [file_driver_on_shift, file_enums, file_general, file_google_protobuf_struct, file_google_protobuf_timestamp, file_job, file_organization, file_truck, file_user]);

/**
 * to be deprecated
 *
 * @generated from message raccoonai.RouteEventIn
 */
export type RouteEventIn = Message<"raccoonai.RouteEventIn"> & {
  /**
   * @generated from field: required raccoonai.RouteEvent event = 1;
   */
  event: RouteEvent;

  /**
   * @generated from field: required uint64 route_id = 2 [json_name = "route_id"];
   */
  routeId: bigint;

  /**
   * @generated from field: optional google.protobuf.Struct payload = 3;
   */
  payload?: JsonObject;
};

/**
 * to be deprecated
 *
 * @generated from message raccoonai.RouteEventIn
 */
export type RouteEventInJson = {
  /**
   * @generated from field: required raccoonai.RouteEvent event = 1;
   */
  event?: RouteEventJson;

  /**
   * @generated from field: required uint64 route_id = 2 [json_name = "route_id"];
   */
  route_id?: string;

  /**
   * @generated from field: optional google.protobuf.Struct payload = 3;
   */
  payload?: StructJson;
};

/**
 * Describes the message raccoonai.RouteEventIn.
 * Use `create(RouteEventInSchema)` to create a new message.
 */
export const RouteEventInSchema: GenMessage<RouteEventIn, {jsonType: RouteEventInJson}> = /*@__PURE__*/
  messageDesc(file_route, 0);

/**
 * @generated from message raccoonai.Route
 */
export type Route = Message<"raccoonai.Route"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required uint64 driver_on_shift_id = 4 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * @generated from field: optional double source_lon = 5 [json_name = "source_lon"];
   */
  sourceLon: number;

  /**
   * @generated from field: optional double source_lat = 6 [json_name = "source_lat"];
   */
  sourceLat: number;

  /**
   * @generated from field: optional double destination_lon = 7 [json_name = "destination_lon"];
   */
  destinationLon: number;

  /**
   * @generated from field: optional double destination_lat = 8 [json_name = "destination_lat"];
   */
  destinationLat: number;

  /**
   * @generated from field: optional uint64 author_id = 9 [json_name = "author_id"];
   */
  authorId: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_start_at = 10 [json_name = "plan_start_at"];
   */
  planStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_end_at = 11 [json_name = "plan_end_at"];
   */
  planEndAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_start_at = 12 [json_name = "fact_start_at"];
   */
  factStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_end_at = 13 [json_name = "fact_end_at"];
   */
  factEndAt?: Timestamp;

  /**
   * @generated from field: required raccoonai.RouteStatus status = 14;
   */
  status: RouteStatus;

  /**
   * @generated from field: required bool created_by_ai = 15 [json_name = "created_by_ai"];
   */
  createdByAi: boolean;

  /**
   * @generated from field: optional bool is_pseudo = 16 [json_name = "is_pseudo"];
   */
  isPseudo: boolean;

  /**
   * @generated from field: optional double netto = 17;
   */
  netto: number;

  /**
   * @generated from field: optional uint64 source_location_id = 18 [json_name = "source_location_id"];
   */
  sourceLocationId: bigint;

  /**
   * @generated from field: optional uint64 destination_location_id = 19 [json_name = "destination_location_id"];
   */
  destinationLocationId: bigint;

  /**
   * @generated from field: optional uint64 current_step_idx = 20 [json_name = "current_step_idx"];
   */
  currentStepIdx: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp gps_start_at = 21 [json_name = "gps_start_at"];
   */
  gpsStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp gps_end_at = 22 [json_name = "gps_end_at"];
   */
  gpsEndAt?: Timestamp;

  /**
   * @generated from field: optional uint64 scale_record_id = 23 [json_name = "scale_record_id"];
   */
  scaleRecordId: bigint;

  /**
   * @generated from field: required raccoonai.RouteCategory route_category = 24 [json_name = "route_category"];
   */
  routeCategory: RouteCategory;

  /**
   * @generated from field: repeated raccoonai.Job jobs = 25;
   */
  jobs: Job[];

  /**
   * @generated from field: optional raccoonai.DriverOnShift driver_on_shift = 26 [json_name = "driver_on_shift"];
   */
  driverOnShift?: DriverOnShift;

  /**
   * @generated from field: optional uint64 reward = 27;
   */
  reward: bigint;

  /**
   * @generated from field: optional double design_duration = 28 [json_name = "design_duration"];
   */
  designDuration: number;

  /**
   * @generated from field: optional raccoonai.ScaleRecord scale_record = 29 [json_name = "scale_record"];
   */
  scaleRecord?: ScaleRecord;

  /**
   * Declared consignment-note facts, written only by ConsignmentNoteService.
   *
   * @generated from field: optional double mileage = 30;
   */
  mileage: number;

  /**
   * @generated from field: optional double weight_kg = 31 [json_name = "weight_kg"];
   */
  weightKg: number;

  /**
   * @generated from field: optional double volume = 32;
   */
  volume: number;

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  createdAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updatedAt?: Timestamp;
};

/**
 * @generated from message raccoonai.Route
 */
export type RouteJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required uint64 driver_on_shift_id = 4 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * @generated from field: optional double source_lon = 5 [json_name = "source_lon"];
   */
  source_lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double source_lat = 6 [json_name = "source_lat"];
   */
  source_lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double destination_lon = 7 [json_name = "destination_lon"];
   */
  destination_lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double destination_lat = 8 [json_name = "destination_lat"];
   */
  destination_lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint64 author_id = 9 [json_name = "author_id"];
   */
  author_id?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_start_at = 10 [json_name = "plan_start_at"];
   */
  plan_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_end_at = 11 [json_name = "plan_end_at"];
   */
  plan_end_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_start_at = 12 [json_name = "fact_start_at"];
   */
  fact_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_end_at = 13 [json_name = "fact_end_at"];
   */
  fact_end_at?: TimestampJson;

  /**
   * @generated from field: required raccoonai.RouteStatus status = 14;
   */
  status?: RouteStatusJson;

  /**
   * @generated from field: required bool created_by_ai = 15 [json_name = "created_by_ai"];
   */
  created_by_ai?: boolean;

  /**
   * @generated from field: optional bool is_pseudo = 16 [json_name = "is_pseudo"];
   */
  is_pseudo?: boolean;

  /**
   * @generated from field: optional double netto = 17;
   */
  netto?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint64 source_location_id = 18 [json_name = "source_location_id"];
   */
  source_location_id?: string;

  /**
   * @generated from field: optional uint64 destination_location_id = 19 [json_name = "destination_location_id"];
   */
  destination_location_id?: string;

  /**
   * @generated from field: optional uint64 current_step_idx = 20 [json_name = "current_step_idx"];
   */
  current_step_idx?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp gps_start_at = 21 [json_name = "gps_start_at"];
   */
  gps_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp gps_end_at = 22 [json_name = "gps_end_at"];
   */
  gps_end_at?: TimestampJson;

  /**
   * @generated from field: optional uint64 scale_record_id = 23 [json_name = "scale_record_id"];
   */
  scale_record_id?: string;

  /**
   * @generated from field: required raccoonai.RouteCategory route_category = 24 [json_name = "route_category"];
   */
  route_category?: RouteCategoryJson;

  /**
   * @generated from field: repeated raccoonai.Job jobs = 25;
   */
  jobs?: JobJson[];

  /**
   * @generated from field: optional raccoonai.DriverOnShift driver_on_shift = 26 [json_name = "driver_on_shift"];
   */
  driver_on_shift?: DriverOnShiftJson;

  /**
   * @generated from field: optional uint64 reward = 27;
   */
  reward?: string;

  /**
   * @generated from field: optional double design_duration = 28 [json_name = "design_duration"];
   */
  design_duration?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional raccoonai.ScaleRecord scale_record = 29 [json_name = "scale_record"];
   */
  scale_record?: ScaleRecordJson;

  /**
   * Declared consignment-note facts, written only by ConsignmentNoteService.
   *
   * @generated from field: optional double mileage = 30;
   */
  mileage?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double weight_kg = 31 [json_name = "weight_kg"];
   */
  weight_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double volume = 32;
   */
  volume?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required google.protobuf.Timestamp created_at = 101 [json_name = "created_at"];
   */
  created_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp updated_at = 102 [json_name = "updated_at"];
   */
  updated_at?: TimestampJson;
};

/**
 * Describes the message raccoonai.Route.
 * Use `create(RouteSchema)` to create a new message.
 */
export const RouteSchema: GenMessage<Route, {jsonType: RouteJson}> = /*@__PURE__*/
  messageDesc(file_route, 1);

/**
 * ScaleRecord and RawScaleRecord live here (rather than in scale_service.proto)
 * because Route and ScaleRecord reference each other; mutual references must
 * share a file to avoid a circular import between route.proto and
 * scale_service.proto.
 * TODO: refactor this, probably making separate file for all model messages to avoid circular imports.
 *
 * @generated from message raccoonai.ScaleRecord
 */
export type ScaleRecord = Message<"raccoonai.ScaleRecord"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: optional raccoonai.Organization owner_organization = 2 [json_name = "owner_organization"];
   */
  ownerOrganization?: Organization;

  /**
   * @generated from field: optional raccoonai.Organization service_provider = 3 [json_name = "service_provider"];
   */
  serviceProvider?: Organization;

  /**
   * @generated from field: required double brutto_weight_kg = 4 [json_name = "brutto_weight_kg"];
   */
  bruttoWeightKg: number;

  /**
   * @generated from field: required google.protobuf.Timestamp brutto_scale_ts = 5 [json_name = "brutto_scale_ts"];
   */
  bruttoScaleTs?: Timestamp;

  /**
   * @generated from field: optional double netto_weight_kg = 6 [json_name = "netto_weight_kg"];
   */
  nettoWeightKg: number;

  /**
   * @generated from field: optional google.protobuf.Timestamp netto_scale_ts = 7 [json_name = "netto_scale_ts"];
   */
  nettoScaleTs?: Timestamp;

  /**
   * @generated from field: optional double volume = 8;
   */
  volume: number;

  /**
   * @generated from field: optional bool is_guest_record = 9 [json_name = "is_guest_record"];
   */
  isGuestRecord: boolean;

  /**
   * @generated from field: required raccoonai.WasteType waste_type = 10 [json_name = "waste_type"];
   */
  wasteType: WasteType;

  /**
   * @generated from field: optional raccoonai.Truck truck = 11;
   */
  truck?: Truck;

  /**
   * @generated from field: optional raccoonai.User driver = 12;
   */
  driver?: User;

  /**
   * @generated from field: optional raccoonai.Route route = 13;
   */
  route?: Route;

  /**
   * @generated from field: optional string integration_comments = 14 [json_name = "integration_comments"];
   */
  integrationComments: string;

  /**
   * @generated from field: optional raccoonai.RawScaleRecord origin = 15;
   */
  origin?: RawScaleRecord;

  /**
   * @generated from field: repeated string photos = 16;
   */
  photos: string[];
};

/**
 * ScaleRecord and RawScaleRecord live here (rather than in scale_service.proto)
 * because Route and ScaleRecord reference each other; mutual references must
 * share a file to avoid a circular import between route.proto and
 * scale_service.proto.
 * TODO: refactor this, probably making separate file for all model messages to avoid circular imports.
 *
 * @generated from message raccoonai.ScaleRecord
 */
export type ScaleRecordJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: optional raccoonai.Organization owner_organization = 2 [json_name = "owner_organization"];
   */
  owner_organization?: OrganizationJson;

  /**
   * @generated from field: optional raccoonai.Organization service_provider = 3 [json_name = "service_provider"];
   */
  service_provider?: OrganizationJson;

  /**
   * @generated from field: required double brutto_weight_kg = 4 [json_name = "brutto_weight_kg"];
   */
  brutto_weight_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required google.protobuf.Timestamp brutto_scale_ts = 5 [json_name = "brutto_scale_ts"];
   */
  brutto_scale_ts?: TimestampJson;

  /**
   * @generated from field: optional double netto_weight_kg = 6 [json_name = "netto_weight_kg"];
   */
  netto_weight_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional google.protobuf.Timestamp netto_scale_ts = 7 [json_name = "netto_scale_ts"];
   */
  netto_scale_ts?: TimestampJson;

  /**
   * @generated from field: optional double volume = 8;
   */
  volume?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional bool is_guest_record = 9 [json_name = "is_guest_record"];
   */
  is_guest_record?: boolean;

  /**
   * @generated from field: required raccoonai.WasteType waste_type = 10 [json_name = "waste_type"];
   */
  waste_type?: WasteTypeJson;

  /**
   * @generated from field: optional raccoonai.Truck truck = 11;
   */
  truck?: TruckJson;

  /**
   * @generated from field: optional raccoonai.User driver = 12;
   */
  driver?: UserJson;

  /**
   * @generated from field: optional raccoonai.Route route = 13;
   */
  route?: RouteJson;

  /**
   * @generated from field: optional string integration_comments = 14 [json_name = "integration_comments"];
   */
  integration_comments?: string;

  /**
   * @generated from field: optional raccoonai.RawScaleRecord origin = 15;
   */
  origin?: RawScaleRecordJson;

  /**
   * @generated from field: repeated string photos = 16;
   */
  photos?: string[];
};

/**
 * Describes the message raccoonai.ScaleRecord.
 * Use `create(ScaleRecordSchema)` to create a new message.
 */
export const ScaleRecordSchema: GenMessage<ScaleRecord, {jsonType: ScaleRecordJson}> = /*@__PURE__*/
  messageDesc(file_route, 2);

/**
 * @generated from message raccoonai.RawScaleRecord
 */
export type RawScaleRecord = Message<"raccoonai.RawScaleRecord"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 legacy_id = 2 [json_name = "legacy_id"];
   */
  legacyId: bigint;

  /**
   * @generated from field: optional string truck_number = 3 [json_name = "truck_number"];
   */
  truckNumber: string;

  /**
   * @generated from field: optional string driver_full_name = 4 [json_name = "driver_full_name"];
   */
  driverFullName: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp first_time_scaled_at = 5 [json_name = "first_time_scaled_at"];
   */
  firstTimeScaledAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp second_time_scaled_at = 6 [json_name = "second_time_scaled_at"];
   */
  secondTimeScaledAt?: Timestamp;

  /**
   * @generated from field: optional double brutto_kg = 7 [json_name = "brutto_kg"];
   */
  bruttoKg: number;

  /**
   * @generated from field: optional double netto_kg = 8 [json_name = "netto_kg"];
   */
  nettoKg: number;

  /**
   * @generated from field: optional double tare_kg = 9 [json_name = "tare_kg"];
   */
  tareKg: number;

  /**
   * @generated from field: optional double volume = 10;
   */
  volume: number;

  /**
   * @generated from field: optional string waste_type = 11 [json_name = "waste_type"];
   */
  wasteType: string;

  /**
   * @generated from field: optional string sender = 12;
   */
  sender: string;

  /**
   * @generated from field: optional string receiver = 13;
   */
  receiver: string;

  /**
   * @generated from field: optional string bin = 14;
   */
  bin: string;

  /**
   * @generated from field: repeated string photos = 15;
   */
  photos: string[];

  /**
   * Код номенклатуры в 1С (продукция)
   *
   * @generated from field: optional string product_code = 16 [json_name = "product_code"];
   */
  productCode: string;

  /**
   * Код контрагента в 1С (поставщик)
   *
   * @generated from field: optional string sender_code = 17 [json_name = "sender_code"];
   */
  senderCode: string;

  /**
   * Код контрагента в 1С (получатель)
   *
   * @generated from field: optional string receiver_code = 18 [json_name = "receiver_code"];
   */
  receiverCode: string;

  /**
   * Номер накладной(с весовой)
   *
   * @generated from field: optional string invoice_num = 19 [json_name = "invoice_num"];
   */
  invoiceNum: string;

  /**
   * Код операции с 1С
   *
   * @generated from field: optional string operation_code = 20 [json_name = "operation_code"];
   */
  operationCode: string;

  /**
   * Номер накладной(от поставщика по документам)
   *
   * @generated from field: optional string document_invoice_num = 21 [json_name = "document_invoice_num"];
   */
  documentInvoiceNum: string;

  /**
   * Брутто по документам(поставщика)
   *
   * @generated from field: optional double document_brutto_kg = 22 [json_name = "document_brutto_kg"];
   */
  documentBruttoKg: number;

  /**
   * Нетто по документам(поставщика)
   *
   * @generated from field: optional double document_netto_kg = 23 [json_name = "document_netto_kg"];
   */
  documentNettoKg: number;

  /**
   * Тара по документам(поставщика)
   *
   * @generated from field: optional double document_tare_kg = 24 [json_name = "document_tare_kg"];
   */
  documentTareKg: number;

  /**
   * Объем по документам(поставщика)
   *
   * @generated from field: optional double document_volume = 25 [json_name = "document_volume"];
   */
  documentVolume: number;

  /**
   * Номер пропуска
   *
   * @generated from field: optional string permit_num = 26 [json_name = "permit_num"];
   */
  permitNum: string;

  /**
   * Номер заказа
   *
   * @generated from field: optional string order_num = 27 [json_name = "order_num"];
   */
  orderNum: string;

  /**
   * Номер пломбы
   *
   * @generated from field: optional string seal_num = 28 [json_name = "seal_num"];
   */
  sealNum: string;

  /**
   * Сетевой номер автовесов
   *
   * @generated from field: optional string scale_net_num = 29 [json_name = "scale_net_num"];
   */
  scaleNetNum: string;

  /**
   * Метка на удаление записи
   *
   * @generated from field: optional string delete_mark = 30 [json_name = "delete_mark"];
   */
  deleteMark: string;

  /**
   * Комментарий
   *
   * @generated from field: optional string commentary = 31;
   */
  commentary: string;

  /**
   * Вес при первом завесе
   *
   * @generated from field: optional double weight1 = 32;
   */
  weight1: number;

  /**
   * Вес при втором завесе
   *
   * @generated from field: optional double weight2 = 33;
   */
  weight2: number;

  /**
   * Влажность
   *
   * @generated from field: optional double humidity = 34;
   */
  humidity: number;

  /**
   * Чистый вес нетто с учетом тары и влажности
   *
   * @generated from field: optional double nettomodif = 35;
   */
  nettomodif: number;
};

/**
 * @generated from message raccoonai.RawScaleRecord
 */
export type RawScaleRecordJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 legacy_id = 2 [json_name = "legacy_id"];
   */
  legacy_id?: string;

  /**
   * @generated from field: optional string truck_number = 3 [json_name = "truck_number"];
   */
  truck_number?: string;

  /**
   * @generated from field: optional string driver_full_name = 4 [json_name = "driver_full_name"];
   */
  driver_full_name?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp first_time_scaled_at = 5 [json_name = "first_time_scaled_at"];
   */
  first_time_scaled_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp second_time_scaled_at = 6 [json_name = "second_time_scaled_at"];
   */
  second_time_scaled_at?: TimestampJson;

  /**
   * @generated from field: optional double brutto_kg = 7 [json_name = "brutto_kg"];
   */
  brutto_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double netto_kg = 8 [json_name = "netto_kg"];
   */
  netto_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double tare_kg = 9 [json_name = "tare_kg"];
   */
  tare_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double volume = 10;
   */
  volume?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional string waste_type = 11 [json_name = "waste_type"];
   */
  waste_type?: string;

  /**
   * @generated from field: optional string sender = 12;
   */
  sender?: string;

  /**
   * @generated from field: optional string receiver = 13;
   */
  receiver?: string;

  /**
   * @generated from field: optional string bin = 14;
   */
  bin?: string;

  /**
   * @generated from field: repeated string photos = 15;
   */
  photos?: string[];

  /**
   * Код номенклатуры в 1С (продукция)
   *
   * @generated from field: optional string product_code = 16 [json_name = "product_code"];
   */
  product_code?: string;

  /**
   * Код контрагента в 1С (поставщик)
   *
   * @generated from field: optional string sender_code = 17 [json_name = "sender_code"];
   */
  sender_code?: string;

  /**
   * Код контрагента в 1С (получатель)
   *
   * @generated from field: optional string receiver_code = 18 [json_name = "receiver_code"];
   */
  receiver_code?: string;

  /**
   * Номер накладной(с весовой)
   *
   * @generated from field: optional string invoice_num = 19 [json_name = "invoice_num"];
   */
  invoice_num?: string;

  /**
   * Код операции с 1С
   *
   * @generated from field: optional string operation_code = 20 [json_name = "operation_code"];
   */
  operation_code?: string;

  /**
   * Номер накладной(от поставщика по документам)
   *
   * @generated from field: optional string document_invoice_num = 21 [json_name = "document_invoice_num"];
   */
  document_invoice_num?: string;

  /**
   * Брутто по документам(поставщика)
   *
   * @generated from field: optional double document_brutto_kg = 22 [json_name = "document_brutto_kg"];
   */
  document_brutto_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Нетто по документам(поставщика)
   *
   * @generated from field: optional double document_netto_kg = 23 [json_name = "document_netto_kg"];
   */
  document_netto_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Тара по документам(поставщика)
   *
   * @generated from field: optional double document_tare_kg = 24 [json_name = "document_tare_kg"];
   */
  document_tare_kg?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Объем по документам(поставщика)
   *
   * @generated from field: optional double document_volume = 25 [json_name = "document_volume"];
   */
  document_volume?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Номер пропуска
   *
   * @generated from field: optional string permit_num = 26 [json_name = "permit_num"];
   */
  permit_num?: string;

  /**
   * Номер заказа
   *
   * @generated from field: optional string order_num = 27 [json_name = "order_num"];
   */
  order_num?: string;

  /**
   * Номер пломбы
   *
   * @generated from field: optional string seal_num = 28 [json_name = "seal_num"];
   */
  seal_num?: string;

  /**
   * Сетевой номер автовесов
   *
   * @generated from field: optional string scale_net_num = 29 [json_name = "scale_net_num"];
   */
  scale_net_num?: string;

  /**
   * Метка на удаление записи
   *
   * @generated from field: optional string delete_mark = 30 [json_name = "delete_mark"];
   */
  delete_mark?: string;

  /**
   * Комментарий
   *
   * @generated from field: optional string commentary = 31;
   */
  commentary?: string;

  /**
   * Вес при первом завесе
   *
   * @generated from field: optional double weight1 = 32;
   */
  weight1?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Вес при втором завесе
   *
   * @generated from field: optional double weight2 = 33;
   */
  weight2?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Влажность
   *
   * @generated from field: optional double humidity = 34;
   */
  humidity?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * Чистый вес нетто с учетом тары и влажности
   *
   * @generated from field: optional double nettomodif = 35;
   */
  nettomodif?: number | "NaN" | "Infinity" | "-Infinity";
};

/**
 * Describes the message raccoonai.RawScaleRecord.
 * Use `create(RawScaleRecordSchema)` to create a new message.
 */
export const RawScaleRecordSchema: GenMessage<RawScaleRecord, {jsonType: RawScaleRecordJson}> = /*@__PURE__*/
  messageDesc(file_route, 3);

/**
 * @generated from message raccoonai.RouteCreate
 */
export type RouteCreate = Message<"raccoonai.RouteCreate"> & {
  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: required uint64 driver_on_shift_id = 2 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * @generated from field: required double source_lon = 3 [json_name = "source_lon"];
   */
  sourceLon: number;

  /**
   * @generated from field: required double source_lat = 4 [json_name = "source_lat"];
   */
  sourceLat: number;

  /**
   * @generated from field: optional double destination_lon = 5 [json_name = "destination_lon"];
   */
  destinationLon: number;

  /**
   * @generated from field: optional double destination_lat = 6 [json_name = "destination_lat"];
   */
  destinationLat: number;

  /**
   * @generated from field: optional uint64 author_id = 7 [json_name = "author_id"];
   */
  authorId: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_start_at = 8 [json_name = "plan_start_at"];
   */
  planStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_end_at = 9 [json_name = "plan_end_at"];
   */
  planEndAt?: Timestamp;

  /**
   * @generated from field: optional bool created_by_ai = 10 [json_name = "created_by_ai"];
   */
  createdByAi: boolean;

  /**
   * @generated from field: optional bool is_pseudo = 11 [json_name = "is_pseudo"];
   */
  isPseudo: boolean;

  /**
   * @generated from field: optional double netto = 12;
   */
  netto: number;

  /**
   * @generated from field: optional uint64 source_location_id = 13 [json_name = "source_location_id"];
   */
  sourceLocationId: bigint;

  /**
   * @generated from field: optional uint64 destination_location_id = 14 [json_name = "destination_location_id"];
   */
  destinationLocationId: bigint;

  /**
   * @generated from field: required raccoonai.RouteCategory route_category = 15 [json_name = "route_category"];
   */
  routeCategory: RouteCategory;
};

/**
 * @generated from message raccoonai.RouteCreate
 */
export type RouteCreateJson = {
  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: required uint64 driver_on_shift_id = 2 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * @generated from field: required double source_lon = 3 [json_name = "source_lon"];
   */
  source_lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: required double source_lat = 4 [json_name = "source_lat"];
   */
  source_lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double destination_lon = 5 [json_name = "destination_lon"];
   */
  destination_lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double destination_lat = 6 [json_name = "destination_lat"];
   */
  destination_lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint64 author_id = 7 [json_name = "author_id"];
   */
  author_id?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_start_at = 8 [json_name = "plan_start_at"];
   */
  plan_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_end_at = 9 [json_name = "plan_end_at"];
   */
  plan_end_at?: TimestampJson;

  /**
   * @generated from field: optional bool created_by_ai = 10 [json_name = "created_by_ai"];
   */
  created_by_ai?: boolean;

  /**
   * @generated from field: optional bool is_pseudo = 11 [json_name = "is_pseudo"];
   */
  is_pseudo?: boolean;

  /**
   * @generated from field: optional double netto = 12;
   */
  netto?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional uint64 source_location_id = 13 [json_name = "source_location_id"];
   */
  source_location_id?: string;

  /**
   * @generated from field: optional uint64 destination_location_id = 14 [json_name = "destination_location_id"];
   */
  destination_location_id?: string;

  /**
   * @generated from field: required raccoonai.RouteCategory route_category = 15 [json_name = "route_category"];
   */
  route_category?: RouteCategoryJson;
};

/**
 * Describes the message raccoonai.RouteCreate.
 * Use `create(RouteCreateSchema)` to create a new message.
 */
export const RouteCreateSchema: GenMessage<RouteCreate, {jsonType: RouteCreateJson}> = /*@__PURE__*/
  messageDesc(file_route, 4);

/**
 * @generated from message raccoonai.RouteUpdate
 */
export type RouteUpdate = Message<"raccoonai.RouteUpdate"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: optional uint64 driver_on_shift_id = 3 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * @generated from field: optional double source_lon = 4 [json_name = "source_lon"];
   */
  sourceLon: number;

  /**
   * @generated from field: optional double source_lat = 5 [json_name = "source_lat"];
   */
  sourceLat: number;

  /**
   * @generated from field: optional double destination_lon = 7 [json_name = "destination_lon"];
   */
  destinationLon: number;

  /**
   * @generated from field: optional double destination_lat = 8 [json_name = "destination_lat"];
   */
  destinationLat: number;

  /**
   * todo deprecate start/end updates
   *
   * @generated from field: optional google.protobuf.Timestamp plan_start_at = 9 [json_name = "plan_start_at"];
   */
  planStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_end_at = 10 [json_name = "plan_end_at"];
   */
  planEndAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_start_at = 11 [json_name = "fact_start_at"];
   */
  factStartAt?: Timestamp;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_end_at = 12 [json_name = "fact_end_at"];
   */
  factEndAt?: Timestamp;

  /**
   * to be deprecated
   *
   * @generated from field: optional raccoonai.RouteStatus status = 13;
   */
  status: RouteStatus;

  /**
   * to be deprecated
   *
   * @generated from field: optional bool is_pseudo = 14 [json_name = "is_pseudo"];
   */
  isPseudo: boolean;

  /**
   * to be deprecated
   *
   * @generated from field: optional double netto = 15;
   */
  netto: number;

  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 source_location_id = 16 [json_name = "source_location_id"];
   */
  sourceLocationId: bigint;

  /**
   * @generated from field: optional uint64 destination_location_id = 17 [json_name = "destination_location_id"];
   */
  destinationLocationId: bigint;

  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 current_step_idx = 18 [json_name = "current_step_idx"];
   */
  currentStepIdx: bigint;

  /**
   * @generated from field: optional google.protobuf.Timestamp gps_start_at = 19 [json_name = "gps_start_at"];
   */
  gpsStartAt?: Timestamp;

  /**
   * to be deprecated
   *
   * @generated from field: optional google.protobuf.Timestamp gps_end_at = 20 [json_name = "gps_end_at"];
   */
  gpsEndAt?: Timestamp;

  /**
   * to be deprecated
   *
   * @generated from field: optional raccoonai.RouteCategory route_category = 21 [json_name = "route_category"];
   */
  routeCategory: RouteCategory;
};

/**
 * @generated from message raccoonai.RouteUpdate
 */
export type RouteUpdateJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * to be required
   *
   * @generated from field: optional uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: optional uint64 driver_on_shift_id = 3 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * @generated from field: optional double source_lon = 4 [json_name = "source_lon"];
   */
  source_lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double source_lat = 5 [json_name = "source_lat"];
   */
  source_lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double destination_lon = 7 [json_name = "destination_lon"];
   */
  destination_lon?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * @generated from field: optional double destination_lat = 8 [json_name = "destination_lat"];
   */
  destination_lat?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * todo deprecate start/end updates
   *
   * @generated from field: optional google.protobuf.Timestamp plan_start_at = 9 [json_name = "plan_start_at"];
   */
  plan_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp plan_end_at = 10 [json_name = "plan_end_at"];
   */
  plan_end_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_start_at = 11 [json_name = "fact_start_at"];
   */
  fact_start_at?: TimestampJson;

  /**
   * @generated from field: optional google.protobuf.Timestamp fact_end_at = 12 [json_name = "fact_end_at"];
   */
  fact_end_at?: TimestampJson;

  /**
   * to be deprecated
   *
   * @generated from field: optional raccoonai.RouteStatus status = 13;
   */
  status?: RouteStatusJson;

  /**
   * to be deprecated
   *
   * @generated from field: optional bool is_pseudo = 14 [json_name = "is_pseudo"];
   */
  is_pseudo?: boolean;

  /**
   * to be deprecated
   *
   * @generated from field: optional double netto = 15;
   */
  netto?: number | "NaN" | "Infinity" | "-Infinity";

  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 source_location_id = 16 [json_name = "source_location_id"];
   */
  source_location_id?: string;

  /**
   * @generated from field: optional uint64 destination_location_id = 17 [json_name = "destination_location_id"];
   */
  destination_location_id?: string;

  /**
   * to be deprecated
   *
   * @generated from field: optional uint64 current_step_idx = 18 [json_name = "current_step_idx"];
   */
  current_step_idx?: string;

  /**
   * @generated from field: optional google.protobuf.Timestamp gps_start_at = 19 [json_name = "gps_start_at"];
   */
  gps_start_at?: TimestampJson;

  /**
   * to be deprecated
   *
   * @generated from field: optional google.protobuf.Timestamp gps_end_at = 20 [json_name = "gps_end_at"];
   */
  gps_end_at?: TimestampJson;

  /**
   * to be deprecated
   *
   * @generated from field: optional raccoonai.RouteCategory route_category = 21 [json_name = "route_category"];
   */
  route_category?: RouteCategoryJson;
};

/**
 * Describes the message raccoonai.RouteUpdate.
 * Use `create(RouteUpdateSchema)` to create a new message.
 */
export const RouteUpdateSchema: GenMessage<RouteUpdate, {jsonType: RouteUpdateJson}> = /*@__PURE__*/
  messageDesc(file_route, 5);

/**
 * deprecate and move to route create once migration from old BE finishes
 *
 * @generated from message raccoonai.RouteCreateWithJobsRequest
 */
export type RouteCreateWithJobsRequest = Message<"raccoonai.RouteCreateWithJobsRequest"> & {
  /**
   * @generated from field: required raccoonai.RouteCreate create = 1;
   */
  create?: RouteCreate;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * @generated from field: repeated uint64 job_ids = 10 [json_name = "job_ids"];
   */
  jobIds: bigint[];
};

/**
 * deprecate and move to route create once migration from old BE finishes
 *
 * @generated from message raccoonai.RouteCreateWithJobsRequest
 */
export type RouteCreateWithJobsRequestJson = {
  /**
   * @generated from field: required raccoonai.RouteCreate create = 1;
   */
  create?: RouteCreateJson;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * @generated from field: repeated uint64 job_ids = 10 [json_name = "job_ids"];
   */
  job_ids?: string[];
};

/**
 * Describes the message raccoonai.RouteCreateWithJobsRequest.
 * Use `create(RouteCreateWithJobsRequestSchema)` to create a new message.
 */
export const RouteCreateWithJobsRequestSchema: GenMessage<RouteCreateWithJobsRequest, {jsonType: RouteCreateWithJobsRequestJson}> = /*@__PURE__*/
  messageDesc(file_route, 6);

/**
 * @generated from message raccoonai.RouteListRequest
 */
export type RouteListRequest = Message<"raccoonai.RouteListRequest"> & {
  /**
   * @generated from field: optional raccoonai.DateTimeFilter datetime_filter = 1 [json_name = "datetime_filter"];
   */
  datetimeFilter?: DateTimeFilter;

  /**
   * facets: "status" (RouteStatus).
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 2 [json_name = "list_filter"];
   */
  listFilter?: ListFilter;

  /**
   * @generated from field: repeated uint64 owner_organization_ids = 3 [json_name = "owner_organization_ids"];
   */
  ownerOrganizationIds: bigint[];

  /**
   * @generated from field: repeated uint64 driver_on_shift_ids = 4 [json_name = "driver_on_shift_ids"];
   */
  driverOnShiftIds: bigint[];

  /**
   * @generated from field: optional uint64 driver_id = 5 [json_name = "driver_id"];
   */
  driverId: bigint;

  /**
   * @generated from field: optional uint64 truck_id = 6 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * @generated from field: repeated raccoonai.RouteStatus route_statuses = 7 [json_name = "route_statuses"];
   */
  routeStatuses: RouteStatus[];

  /**
   * @generated from field: repeated raccoonai.JobType job_types = 8 [json_name = "job_types"];
   */
  jobTypes: JobType[];

  /**
   * @generated from field: repeated raccoonai.RouteCategory route_categories = 9 [json_name = "route_categories"];
   */
  routeCategories: RouteCategory[];

  /**
   * @generated from field: optional string search = 10;
   */
  search: string;

  /**
   * Routes with at least one job at one of these pickup locations. Only those
   * jobs are returned.
   *
   * @generated from field: repeated uint64 pickup_location_ids = 11 [json_name = "pickup_location_ids"];
   */
  pickupLocationIds: bigint[];
};

/**
 * @generated from message raccoonai.RouteListRequest
 */
export type RouteListRequestJson = {
  /**
   * @generated from field: optional raccoonai.DateTimeFilter datetime_filter = 1 [json_name = "datetime_filter"];
   */
  datetime_filter?: DateTimeFilterJson;

  /**
   * facets: "status" (RouteStatus).
   *
   * @generated from field: optional raccoonai.ListFilter list_filter = 2 [json_name = "list_filter"];
   */
  list_filter?: ListFilterJson;

  /**
   * @generated from field: repeated uint64 owner_organization_ids = 3 [json_name = "owner_organization_ids"];
   */
  owner_organization_ids?: string[];

  /**
   * @generated from field: repeated uint64 driver_on_shift_ids = 4 [json_name = "driver_on_shift_ids"];
   */
  driver_on_shift_ids?: string[];

  /**
   * @generated from field: optional uint64 driver_id = 5 [json_name = "driver_id"];
   */
  driver_id?: string;

  /**
   * @generated from field: optional uint64 truck_id = 6 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * @generated from field: repeated raccoonai.RouteStatus route_statuses = 7 [json_name = "route_statuses"];
   */
  route_statuses?: RouteStatusJson[];

  /**
   * @generated from field: repeated raccoonai.JobType job_types = 8 [json_name = "job_types"];
   */
  job_types?: JobTypeJson[];

  /**
   * @generated from field: repeated raccoonai.RouteCategory route_categories = 9 [json_name = "route_categories"];
   */
  route_categories?: RouteCategoryJson[];

  /**
   * @generated from field: optional string search = 10;
   */
  search?: string;

  /**
   * Routes with at least one job at one of these pickup locations. Only those
   * jobs are returned.
   *
   * @generated from field: repeated uint64 pickup_location_ids = 11 [json_name = "pickup_location_ids"];
   */
  pickup_location_ids?: string[];
};

/**
 * Describes the message raccoonai.RouteListRequest.
 * Use `create(RouteListRequestSchema)` to create a new message.
 */
export const RouteListRequestSchema: GenMessage<RouteListRequest, {jsonType: RouteListRequestJson}> = /*@__PURE__*/
  messageDesc(file_route, 7);

/**
 * @generated from message raccoonai.RouteList
 */
export type RouteList = Message<"raccoonai.RouteList"> & {
  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 1 [json_name = "list_info"];
   */
  listInfo?: ListInfo;

  /**
   * @generated from field: repeated raccoonai.Route routes = 2;
   */
  routes: Route[];
};

/**
 * @generated from message raccoonai.RouteList
 */
export type RouteListJson = {
  /**
   * @generated from field: optional raccoonai.ListInfo list_info = 1 [json_name = "list_info"];
   */
  list_info?: ListInfoJson;

  /**
   * @generated from field: repeated raccoonai.Route routes = 2;
   */
  routes?: RouteJson[];
};

/**
 * Describes the message raccoonai.RouteList.
 * Use `create(RouteListSchema)` to create a new message.
 */
export const RouteListSchema: GenMessage<RouteList, {jsonType: RouteListJson}> = /*@__PURE__*/
  messageDesc(file_route, 8);

/**
 * @generated from message raccoonai.RouteIdRequest
 */
export type RouteIdRequest = Message<"raccoonai.RouteIdRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.RouteIdRequest
 */
export type RouteIdRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 2 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.RouteIdRequest.
 * Use `create(RouteIdRequestSchema)` to create a new message.
 */
export const RouteIdRequestSchema: GenMessage<RouteIdRequest, {jsonType: RouteIdRequestJson}> = /*@__PURE__*/
  messageDesc(file_route, 9);

/**
 * deprecate and move to route update once migration from old BE finishes
 *
 * @generated from message raccoonai.RouteUpdateWithJobsRequest
 */
export type RouteUpdateWithJobsRequest = Message<"raccoonai.RouteUpdateWithJobsRequest"> & {
  /**
   * @generated from field: required raccoonai.RouteUpdate route = 1;
   */
  route?: RouteUpdate;

  /**
   * @generated from field: repeated uint64 job_ids = 2 [json_name = "job_ids"];
   */
  jobIds: bigint[];

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * deprecate and move to route update once migration from old BE finishes
 *
 * @generated from message raccoonai.RouteUpdateWithJobsRequest
 */
export type RouteUpdateWithJobsRequestJson = {
  /**
   * @generated from field: required raccoonai.RouteUpdate route = 1;
   */
  route?: RouteUpdateJson;

  /**
   * @generated from field: repeated uint64 job_ids = 2 [json_name = "job_ids"];
   */
  job_ids?: string[];

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.RouteUpdateWithJobsRequest.
 * Use `create(RouteUpdateWithJobsRequestSchema)` to create a new message.
 */
export const RouteUpdateWithJobsRequestSchema: GenMessage<RouteUpdateWithJobsRequest, {jsonType: RouteUpdateWithJobsRequestJson}> = /*@__PURE__*/
  messageDesc(file_route, 10);

/**
 * @generated from message raccoonai.RouteForceCompleteRequest
 */
export type RouteForceCompleteRequest = Message<"raccoonai.RouteForceCompleteRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: repeated uint64 jobs_to_complete = 2 [json_name = "jobs_to_complete"];
   */
  jobsToComplete: bigint[];

  /**
   * @generated from field: repeated uint64 jobs_to_unassign = 3 [json_name = "jobs_to_unassign"];
   */
  jobsToUnassign: bigint[];

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.RouteForceCompleteRequest
 */
export type RouteForceCompleteRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: repeated uint64 jobs_to_complete = 2 [json_name = "jobs_to_complete"];
   */
  jobs_to_complete?: string[];

  /**
   * @generated from field: repeated uint64 jobs_to_unassign = 3 [json_name = "jobs_to_unassign"];
   */
  jobs_to_unassign?: string[];

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.RouteForceCompleteRequest.
 * Use `create(RouteForceCompleteRequestSchema)` to create a new message.
 */
export const RouteForceCompleteRequestSchema: GenMessage<RouteForceCompleteRequest, {jsonType: RouteForceCompleteRequestJson}> = /*@__PURE__*/
  messageDesc(file_route, 11);

/**
 * @generated from message raccoonai.RouteCancelRequest
 */
export type RouteCancelRequest = Message<"raccoonai.RouteCancelRequest"> & {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id: bigint;

  /**
   * @generated from field: repeated uint64 jobs_to_cancel = 2 [json_name = "jobs_to_cancel"];
   */
  jobsToCancel: bigint[];

  /**
   * @generated from field: repeated uint64 jobs_to_unassign = 3 [json_name = "jobs_to_unassign"];
   */
  jobsToUnassign: bigint[];

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.RouteCancelRequest
 */
export type RouteCancelRequestJson = {
  /**
   * @generated from field: required uint64 id = 1;
   */
  id?: string;

  /**
   * @generated from field: repeated uint64 jobs_to_cancel = 2 [json_name = "jobs_to_cancel"];
   */
  jobs_to_cancel?: string[];

  /**
   * @generated from field: repeated uint64 jobs_to_unassign = 3 [json_name = "jobs_to_unassign"];
   */
  jobs_to_unassign?: string[];

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.RouteCancelRequest.
 * Use `create(RouteCancelRequestSchema)` to create a new message.
 */
export const RouteCancelRequestSchema: GenMessage<RouteCancelRequest, {jsonType: RouteCancelRequestJson}> = /*@__PURE__*/
  messageDesc(file_route, 12);

/**
 * @generated from message raccoonai.MoveJobsBetweenRoutesRequest
 */
export type MoveJobsBetweenRoutesRequest = Message<"raccoonai.MoveJobsBetweenRoutesRequest"> & {
  /**
   * @generated from field: required uint64 source_route_id = 1 [json_name = "source_route_id"];
   */
  sourceRouteId: bigint;

  /**
   * @generated from field: required uint64 destination_route_id = 2 [json_name = "destination_route_id"];
   */
  destinationRouteId: bigint;

  /**
   * @generated from field: repeated uint64 job_ids = 3 [json_name = "job_ids"];
   */
  jobIds: bigint[];

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.MoveJobsBetweenRoutesRequest
 */
export type MoveJobsBetweenRoutesRequestJson = {
  /**
   * @generated from field: required uint64 source_route_id = 1 [json_name = "source_route_id"];
   */
  source_route_id?: string;

  /**
   * @generated from field: required uint64 destination_route_id = 2 [json_name = "destination_route_id"];
   */
  destination_route_id?: string;

  /**
   * @generated from field: repeated uint64 job_ids = 3 [json_name = "job_ids"];
   */
  job_ids?: string[];

  /**
   * @generated from field: required uint64 owner_organization_id = 4 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.MoveJobsBetweenRoutesRequest.
 * Use `create(MoveJobsBetweenRoutesRequestSchema)` to create a new message.
 */
export const MoveJobsBetweenRoutesRequestSchema: GenMessage<MoveJobsBetweenRoutesRequest, {jsonType: MoveJobsBetweenRoutesRequestJson}> = /*@__PURE__*/
  messageDesc(file_route, 13);

/**
 * @generated from message raccoonai.ChangeRouteDriverOnShiftRequest
 */
export type ChangeRouteDriverOnShiftRequest = Message<"raccoonai.ChangeRouteDriverOnShiftRequest"> & {
  /**
   * @generated from field: required uint64 route_id = 1 [json_name = "route_id"];
   */
  routeId: bigint;

  /**
   * @generated from field: required uint64 driver_on_shift_id = 2 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.ChangeRouteDriverOnShiftRequest
 */
export type ChangeRouteDriverOnShiftRequestJson = {
  /**
   * @generated from field: required uint64 route_id = 1 [json_name = "route_id"];
   */
  route_id?: string;

  /**
   * @generated from field: required uint64 driver_on_shift_id = 2 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.ChangeRouteDriverOnShiftRequest.
 * Use `create(ChangeRouteDriverOnShiftRequestSchema)` to create a new message.
 */
export const ChangeRouteDriverOnShiftRequestSchema: GenMessage<ChangeRouteDriverOnShiftRequest, {jsonType: ChangeRouteDriverOnShiftRequestJson}> = /*@__PURE__*/
  messageDesc(file_route, 14);

/**
 * @generated from message raccoonai.CreateRouteFromPickupLocationGroupRequest
 */
export type CreateRouteFromPickupLocationGroupRequest = Message<"raccoonai.CreateRouteFromPickupLocationGroupRequest"> & {
  /**
   * @generated from field: required uint64 pickup_location_group_id = 1 [json_name = "pickup_location_group_id"];
   */
  pickupLocationGroupId: bigint;

  /**
   * @generated from field: required google.protobuf.Timestamp date = 2;
   */
  date?: Timestamp;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.CreateRouteFromPickupLocationGroupRequest
 */
export type CreateRouteFromPickupLocationGroupRequestJson = {
  /**
   * @generated from field: required uint64 pickup_location_group_id = 1 [json_name = "pickup_location_group_id"];
   */
  pickup_location_group_id?: string;

  /**
   * @generated from field: required google.protobuf.Timestamp date = 2;
   */
  date?: TimestampJson;

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.CreateRouteFromPickupLocationGroupRequest.
 * Use `create(CreateRouteFromPickupLocationGroupRequestSchema)` to create a new message.
 */
export const CreateRouteFromPickupLocationGroupRequestSchema: GenMessage<CreateRouteFromPickupLocationGroupRequest, {jsonType: CreateRouteFromPickupLocationGroupRequestJson}> = /*@__PURE__*/
  messageDesc(file_route, 15);

/**
 * One route. Unset source/destination fall back to the truck's depot, as in
 * the daily generator. The route category comes from the first stop.
 *
 * @generated from message raccoonai.RouteTrip
 */
export type RouteTrip = Message<"raccoonai.RouteTrip"> & {
  /**
   * @generated from field: optional uint64 source_location_id = 1 [json_name = "source_location_id"];
   */
  sourceLocationId: bigint;

  /**
   * unloading depot
   *
   * @generated from field: optional uint64 destination_location_id = 2 [json_name = "destination_location_id"];
   */
  destinationLocationId: bigint;

  /**
   * In visit order; step_idx = index + 1. What a container group stop becomes
   * is up to the request carrying the trip.
   *
   * @generated from field: repeated raccoonai.JobStop stops = 3;
   */
  stops: JobStop[];
};

/**
 * One route. Unset source/destination fall back to the truck's depot, as in
 * the daily generator. The route category comes from the first stop.
 *
 * @generated from message raccoonai.RouteTrip
 */
export type RouteTripJson = {
  /**
   * @generated from field: optional uint64 source_location_id = 1 [json_name = "source_location_id"];
   */
  source_location_id?: string;

  /**
   * unloading depot
   *
   * @generated from field: optional uint64 destination_location_id = 2 [json_name = "destination_location_id"];
   */
  destination_location_id?: string;

  /**
   * In visit order; step_idx = index + 1. What a container group stop becomes
   * is up to the request carrying the trip.
   *
   * @generated from field: repeated raccoonai.JobStop stops = 3;
   */
  stops?: JobStopJson[];
};

/**
 * Describes the message raccoonai.RouteTrip.
 * Use `create(RouteTripSchema)` to create a new message.
 */
export const RouteTripSchema: GenMessage<RouteTrip, {jsonType: RouteTripJson}> = /*@__PURE__*/
  messageDesc(file_route, 16);

/**
 * Routes from the stop list the dispatcher settled on. One transaction: jobs,
 * shift, routes (CREATED). Schedules only pick windows, never reject:
 * a container group stop takes its schedule window (JobStop.tw_start_at) and
 * that window's job, else the whole day and the owner's unrouted job of the
 * day. A new job is executed by the owner, whose route takes it.
 *
 * @generated from message raccoonai.CreateRoutesFromStopsRequest
 */
export type CreateRoutesFromStopsRequest = Message<"raccoonai.CreateRoutesFromStopsRequest"> & {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;

  /**
   * service day, Asia/Almaty
   *
   * @generated from field: required google.protobuf.Timestamp date = 2;
   */
  date?: Timestamp;

  /**
   * Shift to attach the routes to. Unset: the truck's shift for the day, or a
   * new NOT_APPROVED shift without a driver.
   *
   * @generated from field: optional uint64 driver_on_shift_id = 3 [json_name = "driver_on_shift_id"];
   */
  driverOnShiftId: bigint;

  /**
   * Ignored when driver_on_shift_id is set. Unset: the group's default truck.
   * Without a shift and without a truck (none given, no group or no default
   * truck): ERROR_CODE_REQUIRED_FIELD_MISSING /
   * ERROR_CODE_PICKUP_LOCATION_GROUP_NO_DEFAULT_TRUCK.
   *
   * @generated from field: optional uint64 truck_id = 4 [json_name = "truck_id"];
   */
  truckId: bigint;

  /**
   * At least one, each with at least one stop
   * (ERROR_CODE_REQUIRED_FIELD_MISSING). A job_id stop must be a CREATED,
   * unrouted job of the owner (ERROR_CODE_NOT_FOUND); one job twice among the
   * stops fails with ERROR_CODE_ROUTE_STOP_DUPLICATE_JOB.
   *
   * @generated from field: repeated raccoonai.RouteTrip trips = 5;
   */
  trips: RouteTrip[];

  /**
   * The group the stops come from: container group stops must be its links,
   * new jobs carry it, and only its jobs are reused (a window job of another
   * group fails with ERROR_CODE_JOB_ALREADY_ASSIGNED).
   *
   * @generated from field: optional uint64 pickup_location_group_id = 6 [json_name = "pickup_location_group_id"];
   */
  pickupLocationGroupId: bigint;

  /**
   * The dispatcher confirmed duplicates: a window whose job is routed, past
   * CREATED or another group's gets a new job instead of
   * ERROR_CODE_JOB_ALREADY_ASSIGNED.
   *
   * @generated from field: optional bool allow_duplicates = 7 [json_name = "allow_duplicates"];
   */
  allowDuplicates: boolean;
};

/**
 * Routes from the stop list the dispatcher settled on. One transaction: jobs,
 * shift, routes (CREATED). Schedules only pick windows, never reject:
 * a container group stop takes its schedule window (JobStop.tw_start_at) and
 * that window's job, else the whole day and the owner's unrouted job of the
 * day. A new job is executed by the owner, whose route takes it.
 *
 * @generated from message raccoonai.CreateRoutesFromStopsRequest
 */
export type CreateRoutesFromStopsRequestJson = {
  /**
   * @generated from field: required uint64 owner_organization_id = 1 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;

  /**
   * service day, Asia/Almaty
   *
   * @generated from field: required google.protobuf.Timestamp date = 2;
   */
  date?: TimestampJson;

  /**
   * Shift to attach the routes to. Unset: the truck's shift for the day, or a
   * new NOT_APPROVED shift without a driver.
   *
   * @generated from field: optional uint64 driver_on_shift_id = 3 [json_name = "driver_on_shift_id"];
   */
  driver_on_shift_id?: string;

  /**
   * Ignored when driver_on_shift_id is set. Unset: the group's default truck.
   * Without a shift and without a truck (none given, no group or no default
   * truck): ERROR_CODE_REQUIRED_FIELD_MISSING /
   * ERROR_CODE_PICKUP_LOCATION_GROUP_NO_DEFAULT_TRUCK.
   *
   * @generated from field: optional uint64 truck_id = 4 [json_name = "truck_id"];
   */
  truck_id?: string;

  /**
   * At least one, each with at least one stop
   * (ERROR_CODE_REQUIRED_FIELD_MISSING). A job_id stop must be a CREATED,
   * unrouted job of the owner (ERROR_CODE_NOT_FOUND); one job twice among the
   * stops fails with ERROR_CODE_ROUTE_STOP_DUPLICATE_JOB.
   *
   * @generated from field: repeated raccoonai.RouteTrip trips = 5;
   */
  trips?: RouteTripJson[];

  /**
   * The group the stops come from: container group stops must be its links,
   * new jobs carry it, and only its jobs are reused (a window job of another
   * group fails with ERROR_CODE_JOB_ALREADY_ASSIGNED).
   *
   * @generated from field: optional uint64 pickup_location_group_id = 6 [json_name = "pickup_location_group_id"];
   */
  pickup_location_group_id?: string;

  /**
   * The dispatcher confirmed duplicates: a window whose job is routed, past
   * CREATED or another group's gets a new job instead of
   * ERROR_CODE_JOB_ALREADY_ASSIGNED.
   *
   * @generated from field: optional bool allow_duplicates = 7 [json_name = "allow_duplicates"];
   */
  allow_duplicates?: boolean;
};

/**
 * Describes the message raccoonai.CreateRoutesFromStopsRequest.
 * Use `create(CreateRoutesFromStopsRequestSchema)` to create a new message.
 */
export const CreateRoutesFromStopsRequestSchema: GenMessage<CreateRoutesFromStopsRequest, {jsonType: CreateRoutesFromStopsRequestJson}> = /*@__PURE__*/
  messageDesc(file_route, 17);

/**
 * One stop of a pseudo-route: either a job created together with the route, or
 * an existing unrouted one picked into it. Exactly one of the two is set.
 *
 * @generated from message raccoonai.PseudoRouteStop
 */
export type PseudoRouteStop = Message<"raccoonai.PseudoRouteStop"> & {
  /**
   * @generated from field: optional raccoonai.JobCreate create = 1;
   */
  create?: JobCreate;

  /**
   * @generated from field: optional uint64 job_id = 2 [json_name = "job_id"];
   */
  jobId: bigint;
};

/**
 * One stop of a pseudo-route: either a job created together with the route, or
 * an existing unrouted one picked into it. Exactly one of the two is set.
 *
 * @generated from message raccoonai.PseudoRouteStop
 */
export type PseudoRouteStopJson = {
  /**
   * @generated from field: optional raccoonai.JobCreate create = 1;
   */
  create?: JobCreateJson;

  /**
   * @generated from field: optional uint64 job_id = 2 [json_name = "job_id"];
   */
  job_id?: string;
};

/**
 * Describes the message raccoonai.PseudoRouteStop.
 * Use `create(PseudoRouteStopSchema)` to create a new message.
 */
export const PseudoRouteStopSchema: GenMessage<PseudoRouteStop, {jsonType: PseudoRouteStopJson}> = /*@__PURE__*/
  messageDesc(file_route, 18);

/**
 * @generated from message raccoonai.PseudoRouteCreateRequest
 */
export type PseudoRouteCreateRequest = Message<"raccoonai.PseudoRouteCreateRequest"> & {
  /**
   * @generated from field: required raccoonai.RouteCreate route = 1;
   */
  route?: RouteCreate;

  /**
   * Stops in the order the dispatcher arranged them; the index is the step_idx.
   * Their windows are derived from the route's, not sent by the client.
   *
   * @generated from field: repeated raccoonai.PseudoRouteStop stops = 2;
   */
  stops: PseudoRouteStop[];

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  ownerOrganizationId: bigint;
};

/**
 * @generated from message raccoonai.PseudoRouteCreateRequest
 */
export type PseudoRouteCreateRequestJson = {
  /**
   * @generated from field: required raccoonai.RouteCreate route = 1;
   */
  route?: RouteCreateJson;

  /**
   * Stops in the order the dispatcher arranged them; the index is the step_idx.
   * Their windows are derived from the route's, not sent by the client.
   *
   * @generated from field: repeated raccoonai.PseudoRouteStop stops = 2;
   */
  stops?: PseudoRouteStopJson[];

  /**
   * @generated from field: required uint64 owner_organization_id = 3 [json_name = "owner_organization_id"];
   */
  owner_organization_id?: string;
};

/**
 * Describes the message raccoonai.PseudoRouteCreateRequest.
 * Use `create(PseudoRouteCreateRequestSchema)` to create a new message.
 */
export const PseudoRouteCreateRequestSchema: GenMessage<PseudoRouteCreateRequest, {jsonType: PseudoRouteCreateRequestJson}> = /*@__PURE__*/
  messageDesc(file_route, 19);

